import { render } from "./TvmPageRedirectComponent.vue?vue&type=template&id=1b98e8a8"
import script from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"
export * from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/TvmPageRedirectComponent/TvmPageRedirectComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b98e8a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b98e8a8', __exports__)) {
    api.reload('1b98e8a8', __exports__)
  }
  
  module.hot.accept("./TvmPageRedirectComponent.vue?vue&type=template&id=1b98e8a8", () => {
    api.rerender('1b98e8a8', render)
  })

}


export default __exports__